export default "__VITE_ASSET__CXT8wfOE__"